import { render, staticRenderFns } from "./BankJournalHub.vue?vue&type=template&id=667e3436&scoped=true"
import script from "./BankJournalHub.vue?vue&type=script&lang=js"
export * from "./BankJournalHub.vue?vue&type=script&lang=js"
import style0 from "./BankJournalHub.vue?vue&type=style&index=0&id=667e3436&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667e3436",
  null
  
)

export default component.exports